import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { UpdateQuestionData } from "./generatedQuesPopup";
import api from "@/components/customAxios/Axios";
import { useToast } from "../toast";
import Loader from "../Loader";

export default function UpdateQuestionPopup({
	onClose,
	data,
	setGetNewQuestions,
}: {
	onClose: () => void;
	data: UpdateQuestionData | undefined;
	setGetNewQuestions: React.Dispatch<React.SetStateAction<boolean>>;
}) {
	const toast = useToast();
	const [question, setQuestion] = useState("");
	const [difficulty, setDifficulty] = useState("Easy");
	const [updating, setUpdating] = useState(false);

	const handleUpdate = () => {
		if (!data) return;
		setUpdating(true);
		const payload = {
			resume_id: data.resume_id,
			job_id: data.job_id,
			question_id: data.question_id,
			question_type: data.question_type,
			topic_prompt: question,
			difficult_level: difficulty,
		};
		try {
			api
				.post("/update_candidate_question", payload, {
					headers: { "Content-Type": "application/json" },
				})
				.then((response) => {
					if (response.status === 200) {
						setGetNewQuestions((prev) => !prev);
						onClose();
					}
					setUpdating(false);
					toast.success({
						type: "background",
						duration: 3000,
						status: "Success",
						title: "Question Updated Successfully",
						description: "",
						open: true,
					});
				})
				.catch((error) => {
					setUpdating(false);
					toast.error({
						type: "background",
						duration: 3000,
						status: "Error",
						title: "Error updating question",
						description: error.response?.data?.error || error.response?.data?.message,
						open: true,
					});
				});
		} catch (err: any) {
			setUpdating(false);
			toast.error({
				type: "background",
				duration: 3000,
				status: "Error",
				title: "Error updating question",
				description: err?.response?.data?.error || err?.response?.data?.message || "Failed to update question",
				open: true,
			});
		}
	};

	return (
		<>
			{updating && <Loader />}
			<div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-10">
				<div className="relative bg-white dark:bg-zinc-700 rounded-lg shadow p-6 w-full max-w-[600px] overflow-auto max-h-[calc(100vh-1rem)]">
					<button
						className="absolute top-2 right-2 text-black p-2"
						onClick={onClose}
					>
						<FontAwesomeIcon icon={faTimes} />
					</button>

					<h2 className="text-xl font-semibold mb-2 text-center font-heading">
						Update Question
					</h2>
					<div className="mb-4 font-body">
						<label className="block mb-2">Select Difficulty Level:</label>
						<div className="flex space-x-4">
							{["Easy", "Medium", "Hard"].map((level) => (
								<button
									key={level}
									className={`px-4 py-2 rounded 
                                       text-[#438437] ${difficulty === level
											? "bg-[#BDE4C3] "
											: "border-1"
										}`}
									onClick={() => setDifficulty(level)}
								>
									{level}
								</button>
							))}
						</div>
					</div>
					<div className="mb-4">
						<label htmlFor="question" className="block mb-2 font-subheading">
							Enter Prompt:
						</label>
						<textarea
							id="question"
							className="border border-gray-300 rounded px-2 py-1 w-full"
							rows={5}
							value={question}
							onChange={(e) => setQuestion(e.target.value)}
						></textarea>
					</div>

					<div className="flex justify-start gap-2">
						<button
							className="bg-[#BDE4C3] text-[#438437] px-4 py-2 rounded"
							onClick={handleUpdate}
						// disabled={updating}
						>
							Update
						</button>
						<button
							className="border-1 text-[#438437]  px-4 py-2 rounded"
							onClick={onClose}
						// disabled={updating}
						>
							Cancel
						</button>
					</div>
				</div>
			</div>
		</>
	);
}
